module.exports = __webpack_public_path__ + "img/delivery-fast.994b30a0.svg";